










































































































































import { BuildingState } from '@/store/types';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      rooms: [] as Array<number>,
      floor: [1, 99] as Array<number>,
      minFloor: 1 as number,
      maxFloor: 99 as number,
      square: [1, 99] as Array<number>,
      minSquare: 1 as number,
      maxSquare: 99 as number,
      price: [990000, 99000000] as Array<number>,
      minPrice: 990000 as number,
      maxPrice: 9900000 as number,
      buildings: [] as Array<BuildingState>,
      filteredBuildings: [] as Array<BuildingState>,
    };
  },
  async mounted() {
    await this.$store.dispatch('loadBuildings');
    this.buildings = this.$store.getters.getBuildings;
  },
  methods: {
    filterBuildings(): void {
      this.filteredBuildings = this.buildings.filter(
        // eslint-disable-next-line eqeqeq
        (b) => b.rooms == this.rooms.find((r) => r == b.rooms)
        && b.floor >= this.floor[0]
        && b.floor <= this.floor[1]
        && b.square >= this.square[0]
        && b.square <= this.square[1]
        && b.price >= this.price[0]
        && b.price <= this.price[1],
      );
    },
    applyFilter(): void {
      this.$store.commit('setBuildings', this.filteredBuildings);
    },
    resetFilter(): void {
      this.$store.commit('setBuildings', this.buildings);
      this.rooms = [];
      this.floor = [1, 99];
      this.square = [1, 99];
      this.price = [1000000, 10000000];
      this.filteredBuildings = [];
    },
  },
});
